import LoggerForShowForWidget from './logger_for_show_for_widget'
import Leaflet from '../leaflet_viewer_shared/leaflet'
import LeafletSetNavigationView from '../leaflet_viewer_shared/leaflet_set_navigation_view'
import Scene from '../leaflet_viewer_shared/scene'

jQuery(function ($) {
  const loggerForShowForWidget = new LoggerForShowForWidget($('#view_state').data('view-state').current_leaflet.from_widget_log_url)

  Scene.initClass()
  Leaflet.initClass()

  return new LeafletSetNavigationView(null, loggerForShowForWidget)
})
